import * as is from 'Misc/is';
import { timeCodeToSeconds } from 'Misc/format';
import { getTagContents } from 'Misc/parsers';

export const attrToProp  = (tag, attrs = []) => attrs.reduce( (props, name) => { props[name] = tag.getAttribute(name); return props; }, {});

export const getIcon = tag => {
  const icon     = attrToProp(tag, ['width', 'height', 'xPosition', 'yPosition', 'offset', 'duration', 'program']);
  icon.offset    = timeCodeToSeconds(icon.offset);
  icon.duration  = timeCodeToSeconds(icon.duration);
  icon.src       = getIconSrc(tag);
  icon.tracking  = getIconTracking(tag);
  icon.xPosition = transformPosition(icon.xPosition);
  icon.yPosition = transformPosition(icon.yPosition);
  icon.width     = isNaN(icon.width)  ? icon.width  : Number(icon.width);
  icon.height    = isNaN(icon.height) ? icon.height : Number(icon.height);
  return icon;
};

export const getIconSrc = tag => {
  return (
    ['StaticResource', 'IFrameResource', 'HTMLResource']
      .reduce((src, type) => {
        let content = getTagContents(tag, type);
        if(content) {
          src.type = type;
          src.content = content;
        }
        return src;
      }, {})
  );
};

export const getIconTracking = tag => {
  const clickthrough  = getTagContents(tag, 'IconClickThrough'),
        clicktracking = getTagContents(tag, 'IconClickTracking'),
        viewtracking  = getTagContents(tag, 'IconViewTracking');

  return { clickthrough, clicktracking, viewtracking };
}

export const transformPosition = position => isNaN(position) ? position : Number(position);


// WEBPACK FOOTER //
// ./src/Services/Misc/icon-parsers.js